// extracted by mini-css-extract-plugin
module.exports = {"templateWrapper":"style_templateWrapper__3wCaL","mainWrapper":"style_mainWrapper__337Ml"};